enum GeoFilterType {
    Country,
    City,
    AS,
    Organization,
}

export {
    GeoFilterType,
}